<template>
  <div>
    <div class="sidebar-content">
      <transition-group tag="div" :name="slideDirection">

        <page-one v-if="pageView=='page-one'" :key="1"/>
        <page-two v-if="pageView=='page-two'" :key="2"/>
        <page-three v-if="pageView=='page-three'" :key="3"/>
      </transition-group>
    </div>

    <!--Sidebar Pagination-->
    <div class="pagination">
      <app-pagination
        :values="paginationValues"
        @updated="pageUpdated"
        @over-length="nextSection"
        @under-length="prevSection"
        :startPage="sidebarPageNumber"
      />
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import PageOne from './pages/Page-1'
import PageTwo from './pages/Page-2'
import PageThree from './pages/Page-3'
export default {
  data(){
    return {
      paginationValues: [
        {id: 1, title: "Casting", pannel:"sec-three-pannel-one", pageView:"page-one"},
        {id: 2, title: "Casting", pannel:"sec-three-pannel-two", pageView:"page-two"},
        {id: 3, title: "Casting", pannel:"sec-three-pannel-three", pageView:"page-three"},
      ],
    }
  },
  computed: {
    ...mapGetters({
        sidebarPageNumber: 'sidebar/sidebarPageNumber',
        slideDirection: 'animateSlide/slideDirection'
    }),
    pageView(){
      const pageItem = this.paginationValues.find(el => el.id === this.sidebarPageNumber)
      return pageItem ? pageItem.pageView : null
    }
  },
  components: {
    PageOne,
    PageTwo,
    PageThree
  },
  methods: {
    pageUpdated(sidebar){
      this.$emit('updated', sidebar)
    },
    nextSection(){
      this.$emit('next-section')
    },
    prevSection(){
      this.$emit('prev-section')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/sidebar/sidebar-content.scss';
  @import '@/assets/scss/siteAnimations.scss';
</style>